import * as React from "react";
import { withPrefix } from "gatsby";
import { FigureElement } from "./elements";

const Figure = ({ img, alt, caption }) => (
  <FigureElement>
    <img src={withPrefix(img)} alt={alt || caption} />
    <figcaption dangerouslySetInnerHTML={{ __html: caption }} />
  </FigureElement>
);

export default Figure;
